<script>
  export let show;
  export let top = '25px';
  export let width = undefined;
  export let height = undefined;
</script>

{#if show}
  <div 
    class="modal"
    style:top
    style:width
    style:max-height={height}
    style:overflow-y={height ? 'scroll' : 'none'}
  >
    <slot />
  </div>
{/if}

<style>
  .modal {
    position: absolute;
    background-color: white;
    right: 0;
    font-style: initial;
    box-shadow: 0px 2px 10px 0px #30333D42;
    border-radius: 10px;
    color: #30333D;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0em;
    z-index: 111111;
  }
</style>